import { createPortal } from "react-dom";
import { useDrawerEscape } from "../../lib/hooks/useDrawerEscape";
import { useState } from "react";
import { useAuth, useUserData } from "../../lib/auth";
import { useSettingsStore } from "../../lib/stores/settingsStore";
import { usePermissions } from "../../lib/hooks/usePermissions";
import { customerOrderSettings } from "../../lib/utils/customerOrderSettings";
import { ManualOrderCreateModal } from "../magazzino/ManualOrderCreateModal";
import ManualOrderDetail from "../magazzino/ManualOrderDetail";
import { ClientOrdersSection } from "./ClientOrdersSection";
export function ClientOrderWorkflow({ clientId }: { clientId: string }) {
  const { user } = useAuth();
  const { organizationId } = useUserData();
  const config = customerOrderSettings(useSettingsStore((s) => s.settings));
  const { hasPermission } = usePermissions();
  const [creating, setCreating] = useState(false);
  const [orderId, setOrderId] = useState<string | null>(null);
  const [revision, setRevision] = useState(0);
  useDrawerEscape(
    !!orderId,
    () => {
      setOrderId(null);
      setRevision((n) => n + 1);
    },
    80,
  );
  if (!organizationId || !user || !hasPermission("inventory", "view"))
    return null;
  if (!config.enabled) return <ClientOrdersSection clientId={clientId} />;
  return (
    <section className="border rounded p-3 my-3">
      {config.flow !== "quote" && hasPermission("inventory", "create") && (
        <button
          type="button"
          className="rounded bg-gray-900 text-white px-3 py-2 text-sm"
          onClick={() => setCreating(true)}
        >
          Nuovo ordine
        </button>
      )}
      <ClientOrdersSection
        key={`${clientId}:${revision}`}
        clientId={clientId}
      />
      {creating &&
        createPortal(
          <div className="fixed inset-0 z-[80]">
            <ManualOrderCreateModal
              organizationId={organizationId}
              userId={user.id}
              preselectedClientId={clientId}
              onClose={() => setCreating(false)}
              onSuccess={(id) => {
                setCreating(false);
                setOrderId(id);
                setRevision((n) => n + 1);
              }}
            />
          </div>,
          document.body,
        )}
      {orderId &&
        createPortal(
          <div className="fixed inset-0 z-[80] bg-white overflow-auto">
            <ManualOrderDetail
              organizationId={organizationId}
              orderId={orderId}
              onClose={() => {
                setOrderId(null);
                setRevision((n) => n + 1);
              }}
            />
          </div>,
          document.body,
        )}
    </section>
  );
}
